/* Uses the same public Klaviyo subscription endpoint as the cart drawer. */
if (!customElements.get('bf-newsletter')) {
  customElements.define('bf-newsletter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      if (!form || !this.dataset.company || !this.dataset.list) return;
      this.initialized = true;
      form.noValidate = true;
      const input = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const message = this.querySelector('.bf-newsletter__message');
      const showMessage = (text, error) => {
        message.textContent = text;
        message.hidden = false;
        message.classList.toggle('is-error', error);
      };
      input.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        message.hidden = true;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.pending) return;
        input.value = input.value.trim();
        if (!input.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
          input.setAttribute('aria-invalid', 'true');
          showMessage(this.dataset.invalid, true);
          input.focus();
          return;
        }
        this.pending = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        message.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.dataset.company), {
            method: 'POST',
            headers: { 'content-type': 'application/vnd.api+json', revision: '2026-01-15' },
            signal: controller.signal,
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Black Friday pre-launch newsletter',
                profile: { data: { type: 'profile', attributes: { email: input.value } } }
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
            } })
          });
          if (!response.ok) throw new Error('Subscription failed');
          showMessage(this.dataset.success, false);
          input.removeAttribute('aria-invalid');
          form.reset();
        } catch (error) {
          showMessage(this.dataset.error, true);
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
}
